module.exports = __webpack_public_path__ + "static/media/heatingIcon.0959678e.svg";